import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { formatImage } from '@ifeng-fe/public_method';

class ThanksFor extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.thanksFor}>
                <div className={styles.navBar}>特别鸣谢</div>
                <div className={styles.maps}>
                    {content.map((item, index) => (
                        <div
                            key={index}
                            style={{ marginRight: index === content.length - 1 ? 0 : 24 }}
                            className={styles.mapItem}>
                            <a href={item.url} target="_blank">
                                <div className={styles.img}>
                                    <div className={styles.block} />
                                    {!!item.image && <img src={formatImage(item.image, 221, 116)} alt="" />}
                                </div>
                                <p className={styles.txt}>{item.title}</p>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

const ThanksForChip = props => {
    return (
        <Chip id="170135" type="struct" title="美食盛典-特别鸣谢" groupName="正文-首页" content={props.content}>
            <ThanksFor />
        </Chip>
    );
};

ThanksForChip.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(ThanksForChip);
